import React from "react";

import { Container, SmileLabel } from "./styles";
import {
  VeryUnsatisfied,
  Unsatisfied,
  Neutral,
  Satisfied,
  VerySatisfied
} from "../../../../assets/images";

import { Input } from "../../../../styles/defaults";

function Smile({ response, onValueChange, onClick, guid, questionIndexToModel }) {
  return (
    <Container>
      <Input
        type="radio"
        name="smile"
        id={`veryUnsatisfied-${questionIndexToModel}-${guid}`}
        value={1}
        defaultChecked={parseInt(response) === 1}
        onChange={({ target }) =>
          onValueChange({ response: parseInt(target.value) })
        }
        onClick={({ target }) => onClick(target.value)}
      />
      <SmileLabel
        checked={parseInt(response) === 1}
        selected={response}
        htmlFor={`veryUnsatisfied-${questionIndexToModel}-${guid}`}
      >
        <img src={VeryUnsatisfied} alt="Very Unsatisfied" />
      </SmileLabel>

      <Input
        type="radio"
        name="smile"
        id={`unsatisfied-${questionIndexToModel}-${guid}`}
        value={2}
        defaultChecked={parseInt(response) === 2}
        onChange={({ target }) =>
          onValueChange({ response: parseInt(target.value) })
        }
        onClick={({ target }) => onClick(target.value)}
      />
      <SmileLabel
        checked={parseInt(response) === 2}
        selected={response}
        htmlFor={`unsatisfied-${questionIndexToModel}-${guid}`}
      >
        <img src={Unsatisfied} alt="Unsatisfied" />
      </SmileLabel>

      <Input
        type="radio"
        name="smile"
        id={`neutral-${questionIndexToModel}-${guid}`}
        value={3}
        defaultChecked={parseInt(response) === 3}
        onChange={({ target }) =>
          onValueChange({ response: parseInt(target.value) })
        }
        onClick={({ target }) => onClick(target.value)}
      />
      <SmileLabel
        checked={parseInt(response) === 3}
        selected={response}
        htmlFor={`neutral-${questionIndexToModel}-${guid}`}
      >
        <img src={Neutral} alt="Neutral" />
      </SmileLabel>

      <Input
        type="radio"
        name="smile"
        id={`satisfied-${questionIndexToModel}-${guid}`}
        value={4}
        defaultChecked={parseInt(response) === 4}
        onChange={({ target }) =>
          onValueChange({ response: parseInt(target.value) })
        }
        onClick={({ target }) => onClick(target.value)}
      />
      <SmileLabel
        checked={parseInt(response) === 4}
        selected={response}
        htmlFor={`satisfied-${questionIndexToModel}-${guid}`}
      >
        <img src={Satisfied} alt="Satisfied" />
      </SmileLabel>

      <Input
        type="radio"
        name="smile"
        id={`verySatisfied-${questionIndexToModel}-${guid}`}
        value={5}
        defaultChecked={parseInt(response) === 5}
        onChange={({ target }) =>
          onValueChange({ response: parseInt(target.value) })
        }
        onClick={({ target }) => onClick(target.value)}
      />
      <SmileLabel
        checked={parseInt(response) === 5}
        selected={response}
        htmlFor={`verySatisfied-${questionIndexToModel}-${guid}`}
      >
        <img src={VerySatisfied} alt="Very Satisfied" />
      </SmileLabel>
    </Container>
  );
}

export default Smile;
